import React from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import QuizIcon from '@mui/icons-material/Quiz';
import VideocamIcon from '@mui/icons-material/Videocam';
import { courseSectionTypeEnum } from '../../../../../../helper/constants.helper';

const getIconForType = (type) => {
  switch (type) {
    case courseSectionTypeEnum.ASSESSMENT:
      return ListAltIcon;
    case courseSectionTypeEnum.SLIDES:
      return SlideshowIcon;
    case courseSectionTypeEnum.VIDEO:
      return VideocamIcon;
    case courseSectionTypeEnum.QUIZ:
      return QuizIcon;
    case courseSectionTypeEnum.ACTIVITY:
      return AssignmentIcon;
    default:
      return null;
  }
};

const VisibleTabs = ({ sections, activeIndex, handleNavigation, visitedPages }) => {
  const start = Math.max(0, activeIndex - 2);
  const end = Math.min(sections.length, activeIndex + 3);
  const visibleSections = sections.slice(start, end);

  return (
    <>
      {visibleSections.map((section, index) => {
        const realIndex = start + index;
        const Icon = getIconForType(section.type);

        return (
          <div
            key={section.id}
            onClick={() => handleNavigation(realIndex)}
            className={`nav-button flex-container justify-center align-center ${
              realIndex === activeIndex ? 'active' : ''
            }`}
            style={{
              borderRight: realIndex < sections.length ? '1px solid lightgrey' : 'none',
              borderLeft: realIndex === 0 ? '1px solid lightgrey' : 'none'
            }}>
            {Icon && <Icon style={{ color: visitedPages[section.id] ? 'green' : 'grey' }} />}
          </div>
        );
      })}
      <style jsx>
        {`
          .nav-button {
            border-right: '1px solid lightgrey';
            padding: 10px;
            cursor: pointer;
            font-size: 16px;
            flex-grow: 1;
            text-align: center;
          }
          .nav-button.active {
            border-bottom: 2px solid #0884ff;
          }
        `}
      </style>
    </>
  );
};

export default VisibleTabs;
